<template>
  <div class="animated fadeIn">
    <b-card v-if="!partner && model && model.id">
      <h5 block>
      {{model.permissions || '-'}}
      Partner : {{model.username || '-'}}
      <span class="pull-right">
        {{model.nickname || '-'}}
      </span>
      </h5>
    </b-card>
    <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-danger" v-model="index">
      <b-tab :title="partner || (model && model.id) ? 'Partner' : 'Partner Generation'" border-variant="primary" >
        <div slot="header">
          <strong>Partner Information</strong>
          <span class="pull-right" v-if="!add && model.created_at">Joined_at  : {{model.created_at | datetime}}</span>
        </div>
        <b-row>
          <b-col md="3">
            <b-form-group label="Allow login" label-for="ph_use"
              v-b-tooltip.hover title="Allow login.">
              <c-switch color="info" label size="sm" v-model="model.is_alive" :disabled="lock" />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group>
              <label>Permissions</label>
              <label for="ph" v-b-tooltip.hover title="Permission."></label>
              <v-select :disabled="model && !model.parent_id" v-if="!lock" label="text" v-model="model.permissions" :options="codes.permissions_partner"></v-select>
              <b-form-input type="text" v-if="lock" :value="model.permissions" plaintext></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6" v-if="model.id">
            <b-form-group>
              <label>Last_visit</label>
              <p>
                {{model.last_visit | datetime}} @ {{model.last_addr}}
              </p>
            </b-form-group>
          </b-col>
          <b-col md="6" v-else>
            <b-form-group>
              <label v-if="model && !model.parent_id">
                Partner Group connect
                <br>
                <small>If the partner being created belongs to the same group as the other partner</small>
              </label>
              <label v-else>Partner Group : {{model.parent_username}}</label>
              <b-button variant="primary" @click="partner_connect_modal = true" block>Search</b-button>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group v-if="model.parent_id && model.parent_id != model.id && lock">
              <label>Partner Group Owner</label>
              <label>{{model.parent_username}}</label>
              <b-button v-show="!(model.parent_id && model.parent_id == model.id)" variant="primary" @click="reload" block>View</b-button>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group>
              <label for="ph_username" v-b-tooltip.hover title="Username">Username(ID) (*)
                <span v-if="model.is_del" class="text-danger">Deleted user, Logging in is not possible even if you allow it.</span>
              </label>
              <b-badge v-if="model && model.id && model.parent_id"  :variant="model.parent_id && model.parent_id == model.id ? 'success' : 'primary'">
                * Partner Group {{model.parent_id && model.parent_id == model.id ? ' Master' : 'Member'}}
              </b-badge>
              <b-form-input :disabled="!add || lock" type="text" id="ph_username" v-model="model.username" :plaintext="lock" @change="change_username"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-show="add || !lock">
          <b-col md="6">
            <b-form-group>
              <label for="ph_pass">{{add ? 'User' : 'Change'}} Password(*)</label>
              <b-form-input type="password" id="ph_pass" v-model="model.new_password" :plaintext="lock"></b-form-input>
              <b-badge v-if="model.new_password"  :variant="password_policy('number') ? 'success' : 'danger'"> Number </b-badge>
              <b-badge v-if="model.new_password"  :variant="password_policy('uppercase') ? 'success' : 'danger'"> Upper Characters </b-badge>
              <b-badge v-if="model.new_password"  :variant="password_policy('lowercase') ? 'success' : 'danger'"> Lower Characters </b-badge>
              <b-badge v-if="model.new_password"  :variant="password_policy('spacial') ? 'success' : 'danger'"> Special Characters </b-badge>
              <b-badge v-if="model.new_password"  :variant="password_policy('length') ? 'success' : 'danger'">
                Min Length : 10
              </b-badge>
            </b-form-group>
          </b-col>
          <b-col md="6" v-if="model.new_password">
            <b-form-group>
              <label for="ph_pass2">Password Repeat(*)</label>
              <b-form-input type="password" id="ph_pass2" v-model="model.new_password_repeat" :plaintext="lock"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8">
            <b-form-group>
              <label for="ph_nickname">Nick Name(*)</label>
              <b-form-input type="text" id="ph_nickname" v-model="model.nickname" :plaintext="lock"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Invoice Email Notice" v-b-tooltip.hover title="Sets whether issued invoice is sent or not. Only 'Owner' accounts can be set.">
              <c-switch :disabled="lock || model.parent_id && model.parent_id != model.id" color="info" label size="sm" v-model="model.allow_invoice"/>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group>
              <label for="ph_tax">Tax : [%]</label>
              <b-form-input type="number" id="ph_tax" v-model="model.tax" :plaintext="lock"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <hr>
        <h4>Region</h4>
        <hr>
        <b-row>
          <b-col md="4">
            <b-form-group>
              <label for="ph_country" v-b-tooltip.hover title="country">Country(*)</label>
              <v-select :readonly="true" @input="set_country" :disabled="lock" label="name" v-model="region.country" :options="codes.country" ></v-select>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label for="ph_language" v-b-tooltip.hover title="language">language(*)</label>
              <v-select :readonly="true" @input="set_language" label="name" :disabled="lock" v-model="region.language" :options="codes.language"></v-select>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label for="ph_timezone" v-b-tooltip.hover title="Timezone">Timezone(*)</label>
              <v-select :readonly="true" @input="set_timezone" label="name" :disabled="lock" v-model="region.timezone" :options="codes.timezone" ></v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group>
              <label for="ph_address" v-b-tooltip.hover title="Address for billing">Address(*)</label>
              <b-form-input type="text" id="ph_address" v-model="model.address" :plaintext="lock"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="ph" v-b-tooltip.hover title="Enter a single IP or network range, etc) 192.168.0.100, 192.168.0.0/24 ">List of allowed IPs</label>
              <b-form-textarea ref="allow_ip_list" :rows="model && model.allow_ip ? model.allow_ip.length + 2 : 0" max-rows="10" v-model="model.allow_ip_list" :plaintext="lock"></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <span>* The logo is using when Invoice</span>
            <img v-if="lock" class="text-center" height="120" width="400" :src="model.logo || 'img/F1-uwss.png'" alt="Hello, F1security">
            <b-form-group v-else>
              <!-- v-show="!confirm_save && !confirm_refresh" -->
              <picture-input
                :z-index="2"
                radius="3"
                :prefill="model.logo"

                ref="pictureInput"
                height="140" min-height="150" width="600"  max-width="600" max-height="200"
                accept="image/*" size="2" button-class="btn btn-dark"
                :custom-strings="{
                  upload: '<h1>uploading</h1>',
                  drag: '<small>Drag & Drop<small>',
                }"
                @change="logo_change">
              </picture-input>
            </b-form-group>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="12">
            <b-button size="sm" variant="warning"  v-if="lock && !partner" :disabled="model.is_del" @click="edit">
              {{ partner ? 'Partner' : ''}}{{ model.is_del ? 'Partner was deleted' : 'Edit'}}
            </b-button>
            <b-button size="sm" variant="danger" @click="confirm = true" v-if="lock && !partner"> Remove </b-button>
            <b-button size="sm" variant="info" @click="send_password_reset_mail" v-if="lock && model.id && !partner"> Send Password Reset Mail </b-button>
            <b-button size="sm" variant="primary" @click="send_ip_reset_mail" v-if="lock && model.id"> Send IP ACL Reset Mail </b-button>

            <b-button v-if="!lock" size="sm" class="m-1 pull-right" variant="success" @click="save"> Save </b-button>
            <b-button v-if="!lock" size="sm" class="m-1 pull-right" variant="secondary" @click="cancel"> Cancel </b-button>
            <b-button v-if="partner" size="sm" class="m-1 pull-right" variant="info" @click="$router.push({ name : 'partner', params : { id : partner.id } })"> Partner Detail </b-button>
            <b-button size="sm" class="m-1 pull-right" variant="primary" @click="list"> {{partner ? 'Partner' : ''}} List </b-button>
          </b-col>
        </b-row>
        <hr>
      </b-tab>
      <!-- 해당 부모 파트너와 연결되어 있는 멤버 파트너들 정보 -->
      <b-tab :disabled="!model.id" title="Partner's Memnber">
        <partner-List v-if="check_owner"  :enable_new="false" :parent_id="model.id"></partner-List>
        <b-row v-else>
            <b-col sm="12">
              <center>
                <label>Partner Group : [Owner]</label>
                <label>{{model && model.parent ? model.parent.username : '-'}}</label>
                <b-button variant="primary" @click="reload" block>View</b-button>
              </center>
            </b-col>
          </b-row>
      </b-tab>
      <!-- 파트너 크레딧관리 -->
      <b-tab :disabled="!model.id" v-if="model.id && !partner" title="Partner Billing Setting">
        <b-row v-if="check_owner">
            <b-col>
              <b-card class="g">
                <center style="text-align: center; ">
                  <b>Credit Balance :
                    <sub style="cursor:pointer">
                      <b-badge @click="credit_history_modal = true" variant="primary">
                        History Click!
                      </b-badge>
                    </sub>
                  </b>
                </center>
                <hr>
                <h2>
                  <center style="text-align: center; "><b>${{model.credit | number}}</b></center>
                </h2>
              </b-card>
            </b-col>
            <b-col>
              <b-card class="g">
                <center style="text-align: center; "><b>Credit Charging</b></center><br>
                <b-row>
                  <b-col lg="12" xl="12">
                    <b-row>
                      <b-col md="12">
                        <b-form-group>
                          <label for="ph_name">Credit Deposit or Withdraw</label>
                          <b-input-group size="sm" prepend="$">
                            <b-form-input v-model="amount" placeholder="0.00" type="number"></b-form-input>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12">
                        <b-form-group>
                          <label for="ph_address">Credit Info(*)</label>
                          <b-textarea v-model="amount_log"></b-textarea>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <hr>
                    <b-button-group>
                      <b-button size="sm" variant="info" v-on:click="amount += 10">10</b-button>
                      <b-button size="sm" variant="info" v-on:click="amount += 50">50</b-button>
                      <b-button size="sm" variant="info" v-on:click="amount += 100">100</b-button>
                    </b-button-group>

                    <b-button-group>
                      <b-button size="sm" variant="warning" v-on:click="amount -= 10">-10</b-button>
                      <b-button size="sm" variant="warning" v-on:click="amount -= 50">-50</b-button>
                      <b-button size="sm" variant="warning" v-on:click="amount -= 100">-100</b-button>
                    </b-button-group>
                    <b-button-group class="pull-right">
                      <b-button size="sm" variant="primary" @click="Credit_Add = true">Update</b-button>
                    </b-button-group>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
          <b-row v-else>
            <b-col sm="12">
              <center>
                <label>Partner Group : [Owner]</label>
                <label>{{model && model.parent ? model.parent.username : '-'}}</label>
                <b-button variant="primary" @click="reload" block>View</b-button>
              </center>
            </b-col>
          </b-row>
      </b-tab>
      <!-- 해당 파트너의 가격 정보 시작 -->
      <b-tab :disabled="!model.id" v-if="model.id && !partner" @click="get_partner_service" title="Partner Service">
        <b-row v-if="check_owner">
          <b-col>
            <b-card>
              <template slot="header">
                <i class='fa fa-align-justify'></i> Partner Billing Setting
                <span class="pull-right">Price unit : $</span>
              </template>
              <hr>
                <p class="text-danger font-weight-bold">
                  1. We recommend setting the partner price immediately after creating the partner
                  <br>
                  2. Set whether or not to disclose
                  <br>
                  (price is the first set only once and the default price is will can not set afterward However, promotion is available)
                  <br>
                  3. The price must be disclosed before the partner can create a customer.
                  <br>
                  4. F1's profit is recommended at least cost.
                </p>
              <hr>
              <b-table hover striped small responsive="sm" foot-clone ref="_list_price" show-empty empty-text="There is no payment history!" :items="get_partner_service" :fields="pay">
                <template slot="is_publish" slot-scope="row">
                  <c-switch color="dark" :disabled="published && row.item.is_publish && publish_list.indexOf(row.item.id) < 0" label size="sm" v-model="row.item.is_publish" @change="toggle_publish_service($event, row.item.id, row.item.is_publish)" />
                </template>
                <template slot="service.name" slot-scope="row">{{row.item.service.name}}</template>
                <template slot="service.min_price" slot-scope="row">{{row.item.service.min_price | dollar}} </template>
                <template slot="customer_price" slot-scope="row">
                  <b-input-group prepend="$" class="mb-2 mr-sm-2 mb-sm-0">
                    <b-input size="sm" v-model="row.item.customer_price" :disabled="setting_modify_index == -1 || (setting_modify && setting_modify_index != row.index)"></b-input>
                  </b-input-group>
                </template>
                <template slot="benefit.f1" slot-scope="row">
                  {{ (row.item.customer_price - row.item.partner_price) | dollar}}
                  ({{(((row.item.customer_price - row.item.partner_price) / row.item.customer_price) * 100) | decimal}} %)
                </template>
                <template slot="benefit.partner" slot-scope="row">
                  <b-input-group prepend="$" class="mb-2 mr-sm-2 mb-sm-0">
                    <b-input size="sm" v-model="row.item.partner_price" :disabled="setting_modify_index == -1 || (setting_modify && setting_modify_index != row.index)"></b-input>
                  </b-input-group>
                </template>
                <template slot="func" slot-scope="row">
                  <b-btn class="m-1" :disabled="row.item.is_publish" v-if="setting_modify && setting_modify_index == row.index" size="sm" variant="success" @click="price_save(row.item);" >Apply</b-btn>
                  <b-btn class="m-1" :disabled="row.item.is_publish" v-if="setting_modify && setting_modify_index == row.index" @click="setting_modify = false;setting_modify_index = -1" size="sm" variant="outline-danger">Cancel</b-btn>
                  <b-btn class="m-1" :disabled="row.item.is_publish" v-else @click="setting_modify = true;setting_modify_index = row.index;" size="sm" variant="outline-primary">Modify</b-btn>
                  <b-btn class="m-1" @click="setting_modify_confirm = true" v-if="published && row.item.is_publish && publish_list.indexOf(row.item.id) > -1" size="sm" variant="warning">Publish</b-btn>
                </template>
              </b-table>
              <hr>
              <b-button size="sm" :disabled="published" block variant="primary" @click="setting_modify_confirm = true">
                {{published ? 'Published' : 'Publish' }}
              </b-button>
              <b-button v-if="published" size="sm" :disabled="!published" block variant="warning" @click="service_append_confirm = true">
                Add Exist Service to partner
              </b-button>

            </b-card>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col sm="12">
            <center>
              <label>Partner Group : [Owner]</label>
              <label>{{model && model.parent ? model.parent.username : '-'}}</label>
              <b-button variant="primary" @click="reload" block>View</b-button>
            </center>
          </b-col>
        </b-row>
      </b-tab>
      <!-- 해당 파트너의 가격 정보 끝 -->
      <!-- 해당 파트너의 그룹 정보 -->
      <b-tab :disabled="!model.id" v-if="model.id && !partner" title="Group`s List" @click="() => this.$refs._list && this.$refs._list.refresh()">
        <group-List v-if="check_owner" :partner="model" :addPartner="true" ref="_list"></group-List>
        <b-row v-else>
          <b-col sm="12">
            <center>
              <label>Partner Group : [Owner]</label>
              <label>{{model && model.parent ? model.parent.username : '-'}}</label>
              <b-button variant="primary" @click="reload" block>View</b-button>
            </center>
          </b-col>
        </b-row>
      </b-tab>
      <!-- 해당 파트너의 인보이스 목록 -->
      <b-tab :disabled="!model.id" v-if="model.id && !partner" title="Invoice" @click="() => this.$refs._partner_list && this.$refs._partner_list.refresh()">
        <InvoicePartnerList :ticket="true" :partner_id="model.id" ref="_list_invoice" />
        <hr>
        <b-button size="sm" variant="dark" @click="confirm_ticket_invoice = true;" v-if="model.id"> Ticket Invoice </b-button>
      </b-tab>
      <!-- 해당 파트너의 액션 로그 정보 -->
      <!-- <b-tab :disabled="!model.id" v-if="model.id && !partner" title="Partner Action Log" @click="() => this.$refs._action_list && this.$refs._action_list.refresh()">
        <log-Action-List :user="model" ref="_action_list"></log-Action-List>
      </b-tab> -->

      <!-- 해당 파트너의 로그인 로그 정보 -->
      <!-- <b-tab :disabled="!model.id" v-if="model.id && !partner" title="Partner Login Log">
        <log-Login-List :user="model"></log-Login-List>
      </b-tab> -->
    </b-tabs>

    <!-- 안내 모달 시작 -->
    <b-modal title="partner Remove"  class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
      Are you sure you want to delete this user?
    </b-modal>
    <!-- 파트너 연결 모달 -->
    <b-modal size='xl' title="Connect Partner"  class="modal-primary" v-model="partner_connect_modal" ok-only ok-variant="danger">
      <partner-List :enable_new="false" @select="select_partner" :view_detail="false"></partner-List>
    </b-modal>
    <!-- 크레딧 관련 히스토리 확인 모달 -->
    <b-modal hide-footer title="Manager -> Partner Credit Grant History" size="xl" v-model="credit_history_modal" ok-variant="white">
      <b-table hover striped small responsive="sm" foot-clone ref="_list_credit_history" show-empty empty-text="There is no payment history!"
      :current-page="credit_history_opt.currentPage" :per-page="credit_history_opt.perPage"
      :items="get_credit_list" :fields="history" :sortBy="credit_history_opt.sk">
        <template slot="created_at" slot-scope="row">{{row.item.created_at | date}}</template>
        <template slot="credit_amount" slot-scope="row">{{row.item.credit_amount | number}} </template>
        <template slot="service.list_price" slot-scope="row">{{row.item.service.list_price | number}} </template>
        <template slot="credit_info.invoice_id" slot-scope="row">{{row.item.invoice_id || '-'}} </template>
      </b-table>
      <hr>
      <b-row>
        <b-col class="md-8">
          <b-pagination size="sm" :total-rows="getRowCount()" :per-page="credit_history_opt.perPage" v-model="credit_history_opt.currentPage" prev-text="Prev" next-text="Next"  />
        </b-col>
      </b-row>
      <hr>
      <b-button variant="primary" @click="credit_history_modal = false" block>Close</b-button>
    </b-modal>
    <!-- 크레딧 부여 확인 모달 -->
    <b-modal title="Manager -> Partner Credit Charging" v-model="Credit_Add" @ok="credit_control" ok-variant="primary">
      ${{amount}} Credit Charging??

    </b-modal>
    <!-- 가격 공개 부여 확인 모달 -->
    <b-modal title="Publish to partner's price" v-model="setting_modify_confirm" @ok="setting_publish" ok-variant="danger" header-bg-variant="danger">
      Do you handle the partner's price publicly?
      <hr>
      Only when public processing is complete can partners attract customers
    </b-modal>
    <!-- 파트너 초대 메일 발송 확인 모달 -->
    <b-modal title="Send invitation mail" v-model="mail_confirm" @ok="send_mail" ok-variant="info" header-bg-variant="info">
      Partner, everything is ready.
      <hr>
      Should I send an invitation email to partner ({{model.username}}) ?
    </b-modal>
    <!-- 가격 설정 안내 모달 -->
    <b-modal title="Partner price identification required" no-close-on-backdrop ok-only v-model="is_registed" @ok="index = 3" ok-variant="warning" header-bg-variant="warning">
      Price settings remain for partner
      <br>
      Price information must be reflected before partners can create and manage end customers
    </b-modal>
    <!-- 서비스 추가 모델 -->
    <b-modal title="Another service to apply published partner" no-close-on-backdrop ok-only v-model="service_append_confirm" @ok="service_append" ok-variant="warning" header-bg-variant="warning" size="xl">
      <SettingService
        :view_detail="false"
        @get_basic_service="(service_id) => { this.new_service_id = service_id; service_append() }"
      />

    </b-modal>
    <!-- 인보이스 발급 년월 선택 -->
    <b-modal title="Ticket Invoice"  class="modal-dark" v-model="confirm_ticket_invoice" @ok="ticket_invoice" ok-variant="dark">
      <b-form-group>
        <p>please select the month of invoice</p>
        <hr>
        <vue-monthly-picker selectedBackgroundColor="blue" alignment="center" dateFormat="YYYY-MM" style="width: 100%;" v-model="ticket_invoice_month"> </vue-monthly-picker>
        <!-- <date-picker format="YYYY-MM" style="width: 100%;" v-model="ticket_invoice_month" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker> -->
        <hr>
        <small class="text-danger font-weight-bold">
          If it's already issued, force it to be issued.
          <br>
          Please check the amount of invoice generated.
          <br>
          An information mail will be sent when the invoice is issued.
        </small>
      </b-form-group>
    </b-modal>
    <router-view></router-view>
  </div>
</template>

<style>
.g {
  /* width: 33px; */
  height: 100%;
}

/* .nav-tabs .nav-link{
  border-color : #c8ced3
} */
</style>

<script>

const default_model = () => (
  { is_alive : true, permissions : 'Owner', is_del : false, parent_id : null, parent_username : '', tax : 0.00, allow_invoice : false }
);

let default_opt = function() {
  return {
    perPage: 15,
    currentPage: 1, totalRows: 0,
    sk: '', sv: '', skt: '', opt : {}, adv : false
  }
}

import codes from '@/codes';
import reg from '@/reg';
import { Api } from '@/service';
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import * as forge from 'node-forge'
import * as _ from 'lodash';
import moment from 'moment-timezone';

// another vue
import groupList from '../group/Group.List'
import partnerList from './Partner.List'
import logLoginList from '../../Log/login/Login.List.Partner'
import logActionList from '../../Log/action/Action.List.Partner'
import SettingService from  '../../System/setting/Setting.Service'
import PictureInput from 'vue-picture-input' // https://github.com/alessiomaffeis/vue-picture-input good boy

// invoice
import InvoicePartnerList from '../../Billing/invoice.partner/Invoice.List'
import VueMonthlyPicker from 'vue-monthly-picker'

export default {
  props : ["partner"],
  watch: {
    '$route' (to, from) { this.get(to.params, "from", from); },
    partner() {
      console.log("watch updated props data")
      this.model = this.partner
      let is_done_country = false;
      codes.country.forEach(r => { if(is_done_country) { return; } else if(this.model.country && r.value == this.model.country.toUpperCase()) { this.region.country = r; is_done_country = true } });

      let is_done_language = false;
      codes.language.forEach(r => { if(is_done_language) { return; } else if(this.model.language && r.value == this.model.language.toUpperCase()) { this.region.language = r; is_done_language = true } });

      let is_done_timezone = false;
      codes.timezone.forEach(r => { if(is_done_timezone) { return; } else if(this.model.timezone && r.value == this.model.timezone) { this.region.timezone = r; is_done_timezone = true } });
    }
  },
  components: {
    VueMonthlyPicker,
    InvoicePartnerList,
    PictureInput,
    cSwitch,
    vSelect,
    groupList,
    logLoginList,
    logActionList,
    partnerList,
    SettingService
  },
  data : () => {
		return {
      ticket_invoice_month : '',
      confirm_ticket_invoice : false,
      logo : '',
      publish_list : [],
      published_list : [],
      new_service_id : 0,
      service_append_confirm : false,
      mail_confirm : false,
      is_registed : false,
      index : 0,
      credit_history_opt : default_opt(),
      Credit_Add : false,
      credit_history_modal : false,
      Credit_History : undefined,
      amount : 0.00,
      amount_log : '',
      setting_modify_confirm : false,
      setting_modify : false,
      setting_modify_index : -1,
      partner_price : [],
      codes,
      confirm: false,
      add: false,
      lock: true,
      group_list: undefined,
      model : Object.assign({}, default_model()),
      allowed: false,
      partner_connect_modal : false,
      region : {
        language : codes.language_default,
        country : codes.country_default,
        timezone : codes.timezone_default
      },
      password_meter : { is_spacial : false, is_alphabat_upper : false, is_alphabat_lower : false, is_number : false, check_length : false  },
      published : false
    }
  },
  computed: {
    check_owner() {
      return this.model && this.model.permissions && (this.model.permissions || '').toLowerCase() == 'owner'
    },
    pay() {
      return [
        { key: 'service.name', label: 'Service', sortable: false  },
        { key: 'is_publish', label: 'Publish Status', sortable: false  },
        { key: 'service.min_price', label: 'F1 Cost price(*)', sortable: false  },
        { key: 'customer_price', label: 'List price(To Partner)=A+B', sortable: false  },
        { key: 'benefit.f1', label: "F1's Benefit(A)", sortable: false  },
        { key: 'benefit.partner', label: "Partner's Benefit(B)", sortable: false  },
        { key: 'func', label: "Manage", sortable: false  },
      ]
    },
    history() {
      return [
        { key: 'created_at', label: 'Date', sortable: false  },
        { key: 'credit_amount', label: 'Amount', sortable: false  },
        { key: 'credit_info.from', label: 'From', sortable: false  },
        { key: 'credit_info.to', label: 'To', sortable: false  },
        { key: 'credit_info.to_credit', label: 'To-Credit', sortable: false  },
        { key: 'credit_info.invoice_id', label: 'Invoices', sortable: false  },
        { key: 'credit_info.reason', label: 'Credit Log', sortable: false  },
      ]
    }
  },
  methods: {
    async send_ip_reset_mail() {
      let rs = await Api.Manager_Call('partner', 'mail.ip.reset', { partner_id : this.model.id });
      return rs.is_error ? this.$toastr.e("Sending IP ACL Reset Mail", "failed") : this.$toastr.s("IP ACL Reset Mail", "Sented");
    },
    // 매니저의 강제 인보이스 발급
    ticket_invoice() {
      if(moment(this.ticket_invoice_month).add(-1, 'month').diff(moment(), 'month') >= 0) {
        return this.$toastr.w("Future cannot issue invoice")
      } else if(!this.ticket_invoice_month) {
        return this.$toastr.w("plz, select date")
      }
      console.log(this.ticket_invoice_month.format("yyyy-MM-DD"))
      let body = {
        target : 'invoice.partner', cmd : 'ticket',
        body : {
          partner_id : this.model.id,
          month : this.ticket_invoice_month.format("yyyy-MM-DD")
        }
      }

      return Api.Manager(body)
        .then(rs => {
          if(rs.error) { return this.$toastr.w("failed ticket invoice") }
          this.$refs._list_invoice ? this.$refs._list_invoice.refresh() : ''
          // this.$emit('refresh')
          rs.error ? this.$toastr.w("failed ticket invoice") : this.$toastr.i("created invoice")
        })
        .catch(e => console.log(e));
    },
    logo_change (image) {
      console.log('New picture selected!')
      if (image) {
        console.log('Picture loaded.', image)
        this.logo = image
      } else {
        console.log('FileReader API not supported: use the <form>, Luke!')
      }
    },
    toggle_publish_service(value, id) {
      // console.log(value, id)
      if(this.published_list.indexOf(id) > -1) { console.log('already published', id); return }

      if(value) {
        console.log(id)
        this.publish_list.push(id)
        this.publish_list = _.uniqBy(this.publish_list)
      } else {
        this.publish_list = _.compact(_.filter(this.publish_list, x => x != id))
      }
    },
    async service_append() {
      try {
        if(this.new_service_id < 1) { return this.$toastr.w("plz, select service") }
        // new_service_id 는 베이직 서비스
        let rs = await Api.Manager_Call('partner', 'insert.service', Object.assign({}, { partner_id : this.model.id, new_service_id : this.new_service_id }));
        if(!rs.error) {
          this.$toastr.s('Successfully applied', this.$route.name);
          if(this.$refs._list_price) { this.$refs._list_price.refresh(); }
          this.service_append_confirm = false
        } else {
          this.$toastr.e('Failed to applied, please try again later');
        }
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText) }
    },
    async send_mail() {
      // 초대 메일 발송
      try {
        let rs = await Api.Manager_Call('partner', 'insert.invite', Object.assign({}, { partner_id : this.model.id, url : location.hostname == 'localhost' ? 'https://partner.f1secaas.net/#/auth/reset' : `${location.protocol}//${location.host.replace('manager', 'partner')}//#/auth/reset` }));
        if(!rs.error) {
          this.$toastr.s('Successfully sent mail', this.$route.name);
          if(this.$refs._list_price) { this.$refs._list_price.refresh(); }
          this.mail_confirm = false
        } else {
          this.$toastr.e('Failed to send mail, please try again later');
        }
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    },
    async setting_publish() {
      try {
        let rs = await Api.Manager_Call('partner.license', 'update.publish', Object.assign({}, { partner_id : this.model.id, service_list : this.publish_list }));
        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name);
          if(this.$refs._list_price) { this.$refs._list_price.refresh(); }
          this.published = true
          this.mail_confirm = true
          this.publish_list = [] // 초기화
        } else {
          this.$toastr.e('Save', "failed"); this.list();
        }
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    },
    change_username(value) {
      this.model = Object.assign({}, this.model, { nickname : value.indexOf('@') > -1 ? value.split('@')[0] : value })
    },
    reload() {
      if(!this.model.parent_id || this.model.parent_id == this.model.id) { return this.$toastr.w("already owner selected") }
      this.$router.push({ name: 'partner', params : { id : this.model.parent_id } }); this.$toastr.i("refresh"); this.$emit('refresh') },
    select_partner(item) { this.model = Object.assign({}, this.model, { parent_id : item.id, parent_username : item.username }); this.partner_connect_modal = false; },
    getRowCount() { return this.credit_history_opt && this.credit_history_opt.totalRows || 0; },
    async credit_control(){
      try {
        if(this.amount == 0) { return this.$toastr.w('Number is Zero'); }

        // Partner -> Group Credit Toss Process
        let cmd = this.amount < 0 ? 'update.credit.minus' : 'update.credit.plus'
        let rs = await Api.Manager_Call('partner', cmd, { partner_id : this.model.id, amount : this.amount, reason : this.amount_log  });
        if(rs.error) {return this.$toastr.e("credit control failed", this.$route.name) }

        if(this.$refs._list_credit_history) { this.$refs._list_credit_history.refresh(); }

        this.model.credit = Number(this.model.credit) + Number(this.amount);
        this.$toastr.i('Success!');

      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); }
    },
    async send_password_reset_mail() {
      let rs = await Api.Manager_Call('admin', 'mail.pw.reset', { user_id : this.model.id });
      return rs.is_error ? this.$toastr.e("sending Password Reset Mail", "failed") : this.$toastr.s("Password Reset Mail", "Sented");
    },
    password_policy(type = '')
    {
      switch (type) {
        case 'number':
          this.password_meter.is_number = this.model.new_password && reg.reg_number.test(this.model.new_password) ? true : false;
          return this.password_meter.is_number;
        case 'uppercase':
          this.password_meter.is_alphabat_upper = this.model.new_password && reg.reg_alphabat_upper.test(this.model.new_password) ? true : false;
          return this.password_meter.is_alphabat_upper;
        case 'lowercase':
          this.password_meter.is_alphabat_lower = this.model.new_password && reg.reg_alphabat_lower.test(this.model.new_password) ? true : false;
          return this.password_meter.is_alphabat_lower;
        case 'spacial':
          this.password_meter.is_spacial = this.model.new_password && reg.reg_spacial.test(this.model.new_password) ? true : false;
          return this.password_meter.is_spacial;
        case 'length':
          this.password_meter.check_length = (this.model.new_password && this.model.new_password.length >= 10) ? true : false
          return this.password_meter.check_length;
        // eslint-disable-next-line no-case-declarations
        case 'all':
          let keys = Object.keys(this.password_meter);
          for (let i = 0; i < keys.length; i++) {
            // if has can't pass
            if(!this.password_meter[keys[i]]) { return { is_error : true, key : keys[i] }; }
          }
          // all pass
          return { is_error : false };
        default:
          return false;
      }
    },
    cancel: function() { if(this.$route.params.id == "add") { this.list(); } this.lock = true },
    async remove() {
      try {
        let rs  = await Api.Manager_Call('partner', 'delete', {id : this.model.id});
        if(!rs.error) {
          this.$toastr.s('Removed'); this.list();
        } else {
          this.$toastr.e('delete', "failed"); this.cancel();
        }
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); this.list(); }
    },
    list() { this.$router.push({ name: 'partner'}); this.$emit('refresh'); },
    refresh(id) {
      this.$router.push({ name: 'partner', params : { id : id ? id : this.$route.params.id } });
    },
    edit:function() { this.lock = false },
    set_country:function(x) { if(!x) { return; } this.model.country = x.value },
    set_timezone:function(x) { if(!x) { return; } this.model.timezone = x.value },
    set_language:function(x) { if(!x) { return; } console.log(x, 'sss'); this.model.language = x.value  },
    async price_save(row) {

      let model = {
        partner_id : this.model.id,
        service_id : row.service.id,
        partner_price : parseFloat(row.partner_price),
        // base_price : parseFloat(row.base_price),
        customer_price : parseFloat(row.customer_price), // 파트너의 공개 가격(f1's benefit + partner's benefit)
        service_name : row.service_name,
      }
      console.log('model', model)

      // check validation
      // 편이사님이 제공 가격도 수정을 요청
      // if(row.service.min_price > model.list_price ) { return this.$toastr.e("Can't provide price", "f1 benefit is over Cost price") }

      try {
        let rs = await Api.Manager_Call('partner.price', 'update.price', Object.assign({}, model));
        if(rs.error) { this.$toastr.e("price update failed") }
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }

      try {
        let rs = await Api.Manager_Call('partner.license', 'update', Object.assign({}, model, { id : row.id }));
        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name);
          if(this.$refs._list_price) { this.$refs._list_price.refresh(); }
        } else {
          this.$toastr.e('Save', "failed"); this.list();
        }
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }

      this.setting_modify = false;
      this.setting_modify_index = -1;
    },
    async save() {

      let model = {}

      // check validation
      try {
        if(!(this.model.username || '').trim()) { return this.$toastr.e('Username(ID) Required.'); }
        // if(!this.model.id && !this.model.new_password) { return this.$toastr.e('Password Required.'); }
        if(this.model.new_password && this.model.new_password != this.model.new_password_repeat) { return this.$toastr.e('Password repeat do not match'); }
        if(!(this.model.nickname || '').trim()) { return this.$toastr.e('Nickname Required.'); }
        if(!(this.model.address || '').trim()) { return this.$toastr.e('Address Required.'); }
        if(this.model.new_password) {
          var rs = this.password_policy('all')
          if(rs.is_error) {
            var msg = rs.key.indexOf('is') > -1 ? rs.key.substring(3) : rs.key;
            return this.$toastr.e(`Please check password policy [${msg}]`);
          }
        }
      } catch (e) { console.log(e); return this.$toastr.e('check validation failed'); }
      // 같은 파트너 매핑
      if(this.partner) { this.model.parent = this.partner.id; }

      // build data for sending
      model = Object.assign({}, this.model, { permissions : codes.permissions_partner_value[this.model.permissions] })
      model.tax = parseFloat(this.model.tax).toFixed(2)


      // if(model.parent_id != model.id && model.permissions == codes.permissions_partner_value['Owner']) { return this.$toastr.w('partner group only has 1 owner') }
      if(model.new_password) { model.new_password = forge.sha256.create().update(model.new_password).digest().toHex(); }
      if(model.group && model.group.id) { model.group_id = model.group.id; }
      if(this.model.allow_ip_list) {
        model.allow_ip = _.uniq(_.compact(this.model.allow_ip_list.replace(/,/gm, '').split("\n")));
        // b-form-textarea has bug, can not bind model so rirect update
        this.model.allow_ip_list = _.join(model.allow_ip, '\n')
        this.$refs.allow_ip_list.localValue = _.join(model.allow_ip, '\n')
      } else { model.allow_ip = "" }

      // set logo
      model.logo = this.logo

      // set region
      if(!this.region.country) { return this.$toastr.e('Country Required.'); }
      if(!this.region.timezone) { return this.$toastr.e('Timezone Required.'); }
      if(!this.region.language) { return this.$toastr.e('Language Required.'); }

      let region = {};
      region.country = this.region.country.value
      region.language = this.region.language.value
      region.timezone = this.region.timezone.value

      delete model.group;

      try {
        let rs = await Api.Manager_Call('partner', this.model.id ? 'update' : 'insert', Object.assign({}, model, region));
        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name);
          rs.body.id == this.model.id ? this.$emit('refresh') : this.refresh(rs.body.id)
        } else {
          this.$toastr.e('Save', "failed"); this.list();
        }
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }

      this.lock = true;
    },
    async get_partner_service(ctx) {
      let partner_price_info = {
        target : 'partner.license', cmd : 'list',
        body : { sort : [{ name : "id", op : "desc" }], or : [], and : [{ name : 'partner_id', value : this.model.id, op : '='}, { name : 'is_del', value : false, op : '='}, { name : 'is_alive', value : true, op : '='}] }
      }
      if(ctx.sortBy) { partner_price_info.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      let rs_service = await Api.Manager(partner_price_info)
      this.published = false
      if(rs_service.error) { return this.$toastr.e("service price load failed", this.$route.name) }
      (rs_service.body || []).forEach(r => { if(r.is_publish == true) { this.published = true; this.published_list.push(r.id) } })
      return rs_service && rs_service.body  ? rs_service.body : []
    },
    async get_credit_list(ctx) { return await this.get_credit_info(ctx) },
    async get_credit_info(ctx) {
      let credit_history_opt = {
        target : 'history.credit', cmd : 'list',
        body : {
          sort : [{ name : "id", op : "desc" }],
          or : [],
          and : [ { name : 'partner_id', value : this.model.id, op : '='} ]
        },
        offset : (this.credit_history_opt.currentPage-1 || 0) * Number(this.credit_history_opt.perPage), limit: Number(this.credit_history_opt.perPage),
      }

      if(ctx.sortBy) { credit_history_opt.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }

      let rs = await Api.Manager(credit_history_opt)
      if(rs.error) { return this.$toastr.e("load failed", this.$route.name) }

      this.credit_history_opt.totalRows = rs.total;
      return rs.body
    },
    async get({ id, tag } = this.$route.params) {
      this.model = default_model()

      console.log('partner.detail.vue', 'load item', id, tag);
      if((id === 'add' && (this.partner == false || this.$route.name == "partner"))) { this.add = true; this.lock = false; this.model.is_alive = true; return; }
      try{
        this.model.id = Number(id);
        this.add = false;
        if(this.partner) {
          this.model = this.partner;
        } else {
          let rs = await Api.Manager_Call('partner', 'detail', { id : id })
          if(rs.error) { return this.$toastr.e("load failed", this.$route.name); }
          this.model = Object.assign({ group: {} }, this.model, rs.body)
        }

        let is_done_country = false;
        codes.country.forEach(r => { if(is_done_country) { return; } else if(this.model.country && r.value == this.model.country.toUpperCase()) { this.region.country = r; is_done_country = true } });

        let is_done_language = false;
        codes.language.forEach(r => { if(is_done_language) { return; } else if(this.model.language && r.value == this.model.language.toUpperCase()) { this.region.language = r; is_done_language = true } });

        let is_done_timezone = false;
        codes.timezone.forEach(r => { if(is_done_timezone) { return; } else if(this.model.timezone && r.value == this.model.timezone) { this.region.timezone = r; is_done_timezone = true } });

        // this.index = location.hostname == 'localhost' ? 3 : 0

        console.log(this.model.updated_at, this.model.created_at)

        if(this.model.permissions.toLowerCase() == 'owner') {
          this.is_registed = this.model.updated_at == this.model.created_at
        } else { console.log("this partner not owner, so price is lock") }

      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list() }
    }
  },
  created() { console.log('partner_Detail.vue', 'created'); },
  destroyed() { console.log('partner_Detail.vue', 'destroyed'); },
  mounted() {
    console.log('partner_Detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}
</script>
